import React from 'react';
import {BREAKPOINTS} from '../../../utils/commonHelper';
import PropTypes from 'prop-types';

const BDPContactGroup = ({ formatMessage, messages, phoneNumber, showCallButton, cssClasses, onClick, onClickPhone, onCall}) => {
  const t = formatMessage;
  const {contactGroupWrapClasses, contactGroupClasses, contactButtonClass, callButtonClass, phoneNumberClass} = cssClasses;
  return (
    <div className={contactGroupWrapClasses} >
      <div className={contactGroupClasses}>
        <button className={contactButtonClass} onClick={onClick}>
          {t(messages.contactGroup.contact)}
        </button>
        {showCallButton && (
          <>
            <a className={callButtonClass} href={`tel:${phoneNumber}`} onClick={onClickPhone}>
              {t(messages.contactGroup.call)}
            </a>
            <div className={phoneNumberClass}>
              {`${t(messages.contactGroup.call)}: `}
              <a href={`tel:${phoneNumber}`} onClick={onCall}>
                {phoneNumber}
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

BDPContactGroup.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  messages: PropTypes.object.isRequired,
  showCallButton: PropTypes.bool,
  phoneNumber: PropTypes.string,
  onClick: PropTypes.func,
  onClickPhone: PropTypes.func,
  onCall: PropTypes.func,
  cssClasses: PropTypes.object
};

export default BDPContactGroup;
